"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropDown = void 0;
var _dropDown = require("@clayui/drop-down");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["className", "messages", "trigger"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
/**
 * @deprecated since v3.84.0 - use `Picker` component instead.
 */
var DropDown = exports.DropDown = function DropDown(_ref) {
  var className = _ref.className,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? 'Items Per Page' : _ref$messages,
    trigger = _ref.trigger,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_dropDown.ClayDropDownWithItems, _extends({
    className: (0, _classnames.default)(className, 'pagination-items-per-page'),
    trigger: /*#__PURE__*/_react.default.cloneElement(trigger, {
      'aria-label': messages
    })
  }, otherProps));
};